const func = $target => {
	window.loader.key('matchheight', function() {
		$target.find('.title').matchHeight();
	});
};

export default func;
